import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../../services/apiClient';

export const fetchAuditLogs = createAsyncThunk(
  'audit/fetchAuditLogs',
  async (filters = {}, { rejectWithValue }) => {
    try {
      // On construit les paramètres de l'URL
      const params = new URLSearchParams({
        page: filters.page || 1,
        limit: filters.limit || 10,
        ...filters
      });
      
      const response = await apiClient.get(`/api/v1/audit-logs?${params.toString()}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);